import type { Template } from "@/types";

export const SQ_05_H2_V3: Template[] = [
    {
        id: "sq-05-h2v3-01",
        name: "SQ 01 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 88, y: 63, width: 267, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 63, width: 266, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 88, y: 473, width: 267, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 473, width: 266, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 832, y: 0, width: 487, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-02",
        name: "SQ 02 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 115, y: 0, width: 487, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 805, y: 62, width: 267, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1080, y: 62, width: 266, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 805, y: 251, width: 267, height: 402, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 251, width: 266, height: 402, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-03",
        name: "SQ 03 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 115, y: 0, width: 487, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 805, y: 63, width: 267, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 805, y: 251, width: 267, height: 402, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1079, y: 63, width: 267, height: 402, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 472, width: 267, height: 181, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-04",
        name: "SQ 04 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 156, y: 71, width: 405, height: 575, rotation: 0, imageRotation: 0 },
            { id: "2", x: 787, y: 71, width: 577, height: 364, rotation: 0, imageRotation: 0 },
            { id: "3", x: 787, y: 443, width: 136, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1230, y: 443, width: 134, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 931, y: 443, width: 291, height: 203, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-05",
        name: "SQ 05 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 73, width: 577, height: 302, rotation: 0, imageRotation: 0 },
            { id: "2", x: 70, y: 383, width: 394, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 471, y: 383, width: 176, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 787, y: 143, width: 285, height: 431, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 143, width: 284, height: 431, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-06",
        name: "SQ 06 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 166, width: 577, height: 385, rotation: 0, imageRotation: 0 },
            { id: "2", x: 805, y: 53, width: 540, height: 342, rotation: 0, imageRotation: 0 },
            { id: "3", x: 805, y: 403, width: 175, height: 260, rotation: 0, imageRotation: 0 },
            { id: "4", x: 988, y: 403, width: 175, height: 260, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1171, y: 403, width: 174, height: 260, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-07",
        name: "SQ 07 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 93, width: 338, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 93, width: 380, height: 262, rotation: 0, imageRotation: 0 },
            { id: "3", x: 346, y: 363, width: 380, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 93, width: 346, height: 531, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1088, y: 93, width: 346, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-08",
        name: "SQ 08 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 215, width: 182, height: 288, rotation: 0, imageRotation: 0 },
            { id: "2", x: 189, y: 215, width: 426, height: 288, rotation: 0, imageRotation: 0 },
            { id: "3", x: 622, y: 215, width: 190, height: 288, rotation: 0, imageRotation: 0 },
            { id: "4", x: 819, y: 215, width: 426, height: 288, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1252, y: 215, width: 182, height: 288, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-09",
        name: "SQ 09 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 99, y: 136, width: 296, height: 445, rotation: 0, imageRotation: 0 },
            { id: "2", x: 403, y: 136, width: 295, height: 445, rotation: 0, imageRotation: 0 },
            { id: "3", x: 706, y: 136, width: 295, height: 445, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1009, y: 136, width: 325, height: 219, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1009, y: 363, width: 325, height: 218, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-10",
        name: "SQ 10 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_10.png",
        size: [1434, 717],
        style: {},
        slots: [   
            { id: "1", x: 62, y: 142, width: 296, height: 213, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 363, width: 296, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 366, y: 142, width: 290, height: 433, rotation: 0, imageRotation: 0 },
            { id: "4", x: 788, y: 142, width: 284, height: 433, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 142, width: 283, height: 433, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h2v3-11",
        name: "SQ 11 - H2V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h2_v3_11.png",
        size: [1434, 717],
        style: {},
        slots: [  
            { id: "1", x: 71, y: 142, width: 284, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 142, width: 283, height: 433, rotation: 0, imageRotation: 0 },
            { id: "3", x: 779, y: 142, width: 296, height: 213, rotation: 0, imageRotation: 0 },
            { id: "4", x: 779, y: 363, width: 296, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1083, y: 142, width: 290, height: 433, rotation: 0, imageRotation: 0 }
        ],
    },
    

];

